import GoalTracker from "./GoalTracker";
import { renderGoalTracker } from "../components/GoalTrackerRender";
import { goalTrackerUrlPrefix as urlPrefix } from "../settings/appSettings";

export class GoalTrackerElement extends window.HTMLElement {
    constructor() {
       super();
       this.goalRef = this.getAttribute("goalRef");
       this.attachShadow({mode: 'open'});
       this.addStyles();
       this.wrapperElement = window.document.createElement("div");
       this.wrapperElement.setAttribute("id", this.goalRef);
       this.shadowRoot.append(this.wrapperElement);

       this.goalTrackerInstance = GoalTracker.getInstance(this.goalRef);
       this.goalTrackerInstance.addGoalTrackerElement(this);
       this.props = this.goalTrackerInstance.getProps();

       renderGoalTracker(this.wrapperElement, this.goalRef, this.props);
    }

    addStyles() {
        const linkFontStyles = document.createElement('link');
        linkFontStyles.setAttribute("id", "google-web-fonts-css");
        linkFontStyles.setAttribute("rel", "stylesheet");
        linkFontStyles.setAttribute("type", "text/css");
        linkFontStyles.setAttribute("media", "all");
        linkFontStyles.setAttribute("href", "https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i|Lora:400,400i");

        // Attach the created element to the shadow dom
        this.shadowRoot.appendChild(linkFontStyles);

        // Apply external styles to the shadow dom
        const linkElem = document.createElement('link');
        linkElem.setAttribute('rel', 'stylesheet');
        linkElem.setAttribute('href', `${urlPrefix}goal-tracker.main.min.css`);

        // Attach the created element to the shadow dom
        this.shadowRoot.appendChild(linkElem);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        console.log({name, oldValue, newValue});
    }
}